module.exports = __webpack_public_path__ + "img/ic_ycxd_ok.ae6b8fb0.png";